import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { IconCloudFilled } from '@tabler/icons-react';
import { Indicator, Menu } from '@mantine/core';

export const BlockchainIcon = ({ count }: { count: number }) => {
  const navigate = useNavigate();

  if (!count) {
    return null;
  }

  return (
    <Menu.Item
      onClick={() => navigate(`/history/product/1?filters=blockchain.none`)}
      leftSection={
        <Indicator processing inline size={7}>
          <IconCloudFilled size={18} />
        </Indicator>
      }>
      {t(`toolbar.historyIcon`)}
    </Menu.Item>
  );
};
